import { Mensagem, OrigemMensagem, ArquivoMensagem } from '../../../models/mensagem';
import { MensagemProvider } from '../../../providers/mensagem/mensagem';
import { EmpresaLocalProvider } from '../../../providers/empresa-local/empresa-local';
import { BrComService } from '../../../service/BrComService';
import { FotoProvider } from '../../../providers/foto/foto';
import { Conversa } from './conversa';

export abstract class ConversaContato extends Conversa {

    constructor(protected mensagemProvider: MensagemProvider,
        protected empresaLocalProvider: EmpresaLocalProvider,
        protected brComService: BrComService,
        protected fotoProvider: FotoProvider) {
            super(mensagemProvider, empresaLocalProvider, brComService, fotoProvider);
    }

    protected criarMensagemSimplesEnvio(textoMensagem: string, idUsuarioDestino: number): Mensagem {
        const dataHora = this.mensagemProvider.getDataHoraFormatado();
        const timeStamp = new Date().getTime();
        const mensagem = this.mensagemProvider.criarMensagemSimples({
          idEnvio: timeStamp,
          idMensagemUsuario: 0,
          mensagem: textoMensagem,
          origem: OrigemMensagem.DIREITA,
          idUsuarioDestino: idUsuarioDestino,
          idUsuarioOrigem: this.empresa.IdUsuario,
          textoTipoMensagem: '',
          podeSerRespondida: false,
          data: dataHora.data,
          hora: dataHora.hora,
          dataHora: this.getTimestamp(),
        })
        mensagem.pendente = true;
        return mensagem;
    }

    protected criarMensagemImagemEnvio(idUsuarioDestino: number): Mensagem {
        const dataHora = this.mensagemProvider.getDataHoraFormatado();
        const timeStamp = new Date().getTime();
        const mensagem = this.mensagemProvider.criarMensagemImagem({
          idEnvio: timeStamp,
          idMensagemUsuario: 0,
          link: "",
          origem: OrigemMensagem.DIREITA,
          idUsuarioDestino: idUsuarioDestino,
          idUsuarioOrigem: this.empresa.IdUsuario,
          textoTipoMensagem: '',
          podeSerRespondida: false,
          data: dataHora.data,
          hora: dataHora.hora,
          dataHora: this.getTimestamp(),
        })
        mensagem.pendente = true;
        return mensagem;
    }

    protected criarMensagemArquivoEnvio(idUsuarioDestino: number, arquivo: ArquivoMensagem): Mensagem {
        const dataHora = this.mensagemProvider.getDataHoraFormatado();
        const timeStamp = new Date().getTime();
        const mensagem = this.mensagemProvider.criarMensagemArquivo({
          idEnvio: timeStamp,
          idMensagemUsuario: 0,
          arquivo: arquivo,
          origem: OrigemMensagem.DIREITA,
          idUsuarioDestino: idUsuarioDestino,
          idUsuarioOrigem: this.empresa.IdUsuario,
          textoTipoMensagem: '',
          podeSerRespondida: false,
          data: dataHora.data,
          hora: dataHora.hora,
          dataHora: this.getTimestamp(),
        })
        mensagem.pendente = true;
        return mensagem;
    }

}


// WEBPACK FOOTER //
// ./src/pages/shared/conversa/conversa-contato.ts